/**
 * 派单模块 API
 * 用于手动派单页面的接口调用
 */
import Api from '@/utils/api'
import BasicConfig from '@/config/basic'

/**
 * 单项目预约派单
 */
export function singleProjectAppointment(body) {
  return Api.post(`${BasicConfig.jDomain}/project-plan/submit`, {
    ...body,
    axiosType: 'java'
  })
}

/**
 * 未分配安排：为项目安排指派产康师并落预约
 * POST /project-plan/{id}/assign-technician
 * @param {string|number} id 项目安排 ID
 * @param {{ technicianId: number, appointmentDate?: number, startTime?: number, endTime?: number }} body
 */
export function assignProjectPlanTechnician (id, body) {
  return Api.post(`${BasicConfig.jDomain}/project-plan/${id}/assign-technician`, {
    ...body,
    axiosType: 'java'
  })
}

/**
 * 取消单项目预约（id 为安排 ID，非 memberProjectId）
 */
export function cancelSingleProjectAppointment(id) {
  return Api.delete(`${BasicConfig.jDomain}/project-plan/${id}/cancel`, {
    params: { axiosType: 'java' }
  })
}

/**
 * 查询某会员套餐项目下的预约安排列表
 * @param {string|number} memberProjectId 套餐项目行 id（与 submit 的 memberProjectId 一致）
 */
export function getMemberProjectPlans(memberProjectId) {
  return Api.get(`${BasicConfig.jDomain}/project-plan/member-project/${memberProjectId}`, {
    params: { axiosType: 'java' }
  })
}

/**
 * 查询技师某日已占用时段（用于开始时间禁选）
 * @param {{ technicianId: number, date: number }} query date 为当日 0 点时间戳（毫秒）
 */
export function getTechnicianDayPlan(query) {
  return Api.get(`${BasicConfig.jDomain}/project-plan/technician-day`, {
    params: { ...query, axiosType: 'java' }
  })
}

/**
 * 查询某店某日各技师上下班与休息（用于预约时段与班次对齐）
 * GET /project-plan/technicians
 * @param {{ storeId: string|number, date: number }} query date 为当日 0 点 Unix 秒（10 位）
 */
export function getProjectPlanTechnicians (query) {
  return Api.get(`${BasicConfig.jDomain}/project-plan/technicians`, {
    params: { ...query, axiosType: 'java' }
  })
}

/**
 * 未分配项目计划数量（新订单 Tab 角标）
 * GET /project-plan/unassigned/count
 * @param {Object} [query] - 如 storeId（与未分配列表一致）
 * @returns {Promise<{ data: unknown }>} data 为数字或 { count } 等，由调用方归一
 */
export function getProjectPlanUnassignedCount(query = {}) {
  const params = { axiosType: 'java' }
  if (query.storeId != null && String(query.storeId).trim() !== '') {
    params.storeId = query.storeId
  }
  return Api.get(`${BasicConfig.jDomain}/project-plan/unassigned/count`, {
    params
  })
}

/**
 * 未分配项目计划列表（新订单 Tab）
 * GET /project-plan/unassigned
 * @param {Object} [query] - 如 storeId、keyword（由调用方与后端约定）
 */
export function getProjectPlanUnassigned(query = {}) {
  return Api.get(`${BasicConfig.jDomain}/project-plan/unassigned`, {
    params: { ...query, axiosType: 'java' }
  })
}
